import ClientDto from '../client/client-dto';
import ClientUserDto from '../client/client-user-dto';
import TechspecTypeDto from './techspec-type-dto';
import UserDto from '@vertical-plus/vue-js-micro-service-components/lib/model/entity/organisation/user-dto';

export default class TechspecDto
{
    public id: number|null = null;
    public client: ClientDto|null = null;
    public clientUser: ClientUserDto|null = null;
    public manager: UserDto|null = null;
    public type: TechspecTypeDto|null = null;
    public name = '';
    public description: string|null = null;
    public meetingDate: string|null = null;
    public meetingLocation: string|null = null;
    public deadline: string|null = null;
    public project = false;
    public active = true;
    public dateCreated = '';
    public dateUpdated = '';
}